import HouseMainDetails from './HouseMainDetails'

export { HouseMainDetails }
